import React from 'react';
import StoryActions from './StoryActions';

const StoriesContainer = ({ locked, endOfStory, readOther, storyActions: StoryActions, children }) => (
  <div className="recommended-stories">
    { !locked && <h3 className="tc t-mt3 t-mb3">{endOfStory}</h3> }
    { !locked && <StoryActions /> }
    <h2 className="tc t-mt4 t-mb3">{readOther}</h2>
    <div className="recommended-stories flex flex-wrap justify-start">
      {children}
    </div>
  </div>
)

StoriesContainer.defaultProps = {
  endOfStory: 'You reached the end of this story',
  locked: false,
  readOther: 'Read other stories',
  storyActions: StoryActions
};

export default StoriesContainer;
